import { memo, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { BodyCopy } from "../../../components/BodyCopy";
import {
  Button,
  Layout,
  PageTitle,
} from "lola-framework-ui-test";
import { AuraLayout } from "../../../components/AuraLayout";
import { ErrorAlertIcon as ErrorIcon } from "../../../assets/icons";
import { FlowHeroMark } from "../../../components/FlowHeroMark";
import { useStore } from "../../../store/globalState";
import { useLiveExitUrl } from "../../../hooks/useLiveExitUrl";
import { getEvents, safeCapture } from "../../../analytics";
import { ScrollFadeIndicator } from "../../../components/ScrollFadeIndicator";

export const ServiceUnavailablePage = memo(() => {
  const { t } = useTranslation();
  const { theme } = useStore();
  const callbackUrl = useLiveExitUrl();

  const colorConfig = theme.errorView;
  const { backgroundBtn, textColorBtn, title, bodyCopy, iconColors, backgroundIcon } =
    colorConfig;

  useEffect(() => {
    safeCapture(getEvents().SERVICE_UNAVAILABLE);
  }, []);

  const handleGoToApp = () => {
    if (!callbackUrl) return;
    safeCapture(getEvents().EXIT_CLICK, {
      screen: "service_unavailable",
    });
    window.location.href = callbackUrl;
  };

  return (
    <AuraLayout colorConfig={colorConfig} className="flow-landing-page">
      <Layout.Content className="landing-section flow-hero-section">
        <ScrollFadeIndicator color={colorConfig.bodyCopy} />
        <section className="flow-hero">
          <FlowHeroMark backgroundIcon={backgroundIcon}>
            <ErrorIcon size={60} colors={iconColors} />
          </FlowHeroMark>
          <section className="landing-container">
            <PageTitle
              highlight={t("error.serviceUnavailableTitle")}
              highlightColor={title}
              secudnary=""
              secudnaryColor={title}
            />
            <BodyCopy textColor={bodyCopy}>
              {t("error.serviceUnavailableMessage")}
            </BodyCopy>
          </section>
        </section>
      </Layout.Content>
      {callbackUrl && (
        <Layout.Footer>
          <section className="footer-section">
            <Button
              size="large"
              background={backgroundBtn}
              color={textColorBtn}
              onClick={handleGoToApp}
            >
              {t("error.goToApp")}
            </Button>
          </section>
        </Layout.Footer>
      )}
    </AuraLayout>
  );
});
